import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';

import pageBodyStyles from './PageBody_styles';

export interface PageBodyProps {
  nopad?: boolean;
  children?: any;
}

const PageBody = ({
  children,
  styles,
}: PageBodyProps & StylesProps<typeof pageBodyStyles>) => (
  <div className={cx('PageBody', styles.container)}>{children}</div>
);

export default styled(pageBodyStyles)(PageBody);
